<!-- 
Button for bringing up the relevant section of the user guide
-->
<template>
  <v-tooltip top>
    <v-btn slot="activator" :href="link" :class="'user-guide-button ' + [inTitle ? 'mt-0 mb-1' : '']" 
      icon target="_blank"
    >
      <v-icon color="primary">help</v-icon>
    </v-btn>
    <span>Click to open the relevant section of the user guide</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    topic: {
      type: String,
      required: true
    },
    section: {
      type: String,
      default: ""
    },
    inTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    link() {
      const extra = this.section !== "" ? `#${this.section}` : "";
      if(this.$store.state.system.details.environment === "local"){
        //localhost uses a webpack dev server to serve userguide
        //for higher environments, userguide is published inside subfolder of the root api app
        return `${process.env.VUE_APP_LOCALHOST_USER_GUIDE}${this.topic}.html${extra}`;
      }
      return `${process.env.VUE_APP_USER_GUIDE_BASE_URL}${this.topic}.html${extra}`;
    }
  }
};
</script>
